import React from 'react';
import PropTypes from 'prop-types';
import { Detail, Input } from 'components/common';
import Optional from 'components/common/Optional';

function ProductInfo({
  productName,
  productDescription,
  meetingTime,
  showMeetingTime,
  onProductNameChange,
  onProductDescriptionChange,
  onMeetingTimeChange,
  loading,
  disabled,
}) {
  return (
    <>
      <Detail
        label={
          <>
            Product Name
            <Optional />
          </>
        }
        style={{ marginBottom: '8px' }}
      >
        <Input
          placeholder='Product Name'
          value={productName}
          onChange={onProductNameChange}
          disabled={loading || disabled}
          maxLength={50}
          showCount
          multiline
          rows={1}
          style={{ resize: 'none' }}
        />
      </Detail>
      <Detail
        label={
          <>
            Product Description
            <Optional />
          </>
        }
        style={{ marginBottom: '8px' }}
      >
        <Input
          placeholder='Enter a short description about the product'
          value={productDescription || ''}
          onChange={onProductDescriptionChange}
          disabled={loading || disabled}
          maxLength={500}
          multiline
          autoSize={{ minRows: 1, maxRows: 10 }}
          showCount
        />
      </Detail>
      {showMeetingTime && (
        <Detail
          style={{ marginBottom: '8px' }}
          label={
            <>
              Date Of Visit <Optional />
            </>
          }
        >
          <Input
            placeholder='Date Of Visit'
            value={meetingTime}
            disabled={loading || disabled}
            onChange={onMeetingTimeChange}
            maxLength={50}
            showCount
            multiline
            rows={1}
            style={{ resize: 'none' }}
          />
        </Detail>
      )}
    </>
  );
}

ProductInfo.propTypes = {
  productName: PropTypes.string,
  productDescription: PropTypes.string,
  meetingTime: PropTypes.string,
  showMeetingTime: PropTypes.bool,
  onProductNameChange: PropTypes.func.isRequired,
  onProductDescriptionChange: PropTypes.func.isRequired,
  onMeetingTimeChange: PropTypes.func,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
};

ProductInfo.defaultProps = {
  showMeetingTime: false,
  meetingTime: '',
  productName: '',
  productDescription: '',
};

export default ProductInfo;
